type Currency = 'EUR' | 'USD' | 'GBP' | 'MXN' | 'BRL' | 'COP' | 'ARS'
interface ChargebeeBase {
  currencyCode: Currency
  period: number
  periodUnit: 'day' | 'week' | 'month' | 'year' | 'not_applicable'
  pricingModel: 'flat_fee' | 'per_unit' | 'tiered' | 'volume' | 'stairstep' | 'talk_to_sales'
  price: number | null
  chargeType: 'recurring' | 'non_recurring'
  tiers?: { startingUnit?: number; endingUnit?: number }[]
}

export type PlanStatus = 'current' | 'free' | 'legacy'

export interface ChargebeeAddon extends ChargebeeBase {
  addonId: string
}

export interface ChargebeePlan extends ChargebeeBase {
  planId: string
}

export interface ChargebeeSubscription {
  plan: ChargebeeAddon | ChargebeePlan
  quantity: number
}

export interface SimpleChargebeePlanSubscription {
  planId: string
}

export interface SimpleChargebeeAddonSubscription {
  addonId: string
}

export interface SimpleChargebeeSubscription {
  plan: SimpleChargebeePlanSubscription | SimpleChargebeeAddonSubscription
  quantity: number
}

interface RegionPlanCommon {
  features: {
    title: string
    tooltip?: string
  }[]
}

interface RegionPlan extends RegionPlanCommon {
  chargebeePlans: ChargebeePlan[]
}

interface RegionAddon extends RegionPlanCommon {
  chargebeeAddons: ChargebeeAddon[]
}

export interface F25Plan {
  internalTitle: string
  title: string
  description?: string
  isCorePlan: boolean
  mostPopular: boolean
  f25NormalPlans: F25Addon[]
  f25ExtraAddons: F25Addon[]
  regions: RegionPlan
  inheritFeatures: {
    title: string
    regions: RegionPlan
  }
}

export interface F25Addon {
  internalTitle: string
  title: string
  description?: string
  parentModule: string
  regions: RegionAddon
  iconId: string
  iconLink: string
  inheritFeatures: {
    title: string
    regions: RegionAddon
  }
}

export type ChargebeeBundle = {
  f25ExtraAddons?: F25Addon[]
  chargebeeAddons: (ChargebeeAddon | ChargebeePlan)[]
  minimumSeats: number
  title: string
  internalTitle: string
  description: string
  f25NormalPlans: F25Addon[]
  mostPopular?: boolean
  benefits?: {
    title: string
  }[]
}

export type SimpleSubscriptionItem = {
  itemId: string
  quantity: number
}

export const formatPrice = (number: number, currency: string) => {
  if (currency === 'COP') {
    return (
      '$' +
      `${new Intl.NumberFormat(navigator.language, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(number)}`
    )
  }

  return new Intl.NumberFormat(navigator.language, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(number)
}
